import { isClientSide } from "@/lib/is-client-side"
import { webStorage, WebStorageUnavailableError } from "@/lib/web-storage"

export interface BrowserCapabilities {
  cookiesEnabled: boolean
  localStorageAvailable: boolean
  sessionStorageAvailable: boolean
}

function areCookiesEnabled(): boolean {
  if (navigator.cookieEnabled === false) return false

  try {
    const testKey = "_mindtrip_capability_test"
    document.cookie = `${testKey}=1`
    const enabled = document.cookie.includes(testKey)
    if (enabled) {
      document.cookie = `${testKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC`
    }
    return enabled
  } catch {
    return false
  }
}

export function isStorageAvailable(type: "local" | "session"): boolean {
  const testKey =
    type === "local" ? "__localStorage_test__" : "__sessionStorage_test__"

  try {
    webStorage.setItem(testKey, testKey, { type, noInMemoryFallback: true })
    webStorage.removeItem(testKey, { type, noInMemoryFallback: true })
    return true
  } catch (error) {
    if (error instanceof WebStorageUnavailableError) return false
    throw error
  }
}

export function getBrowserCapabilities(): BrowserCapabilities {
  if (!isClientSide()) {
    return {
      cookiesEnabled: false,
      localStorageAvailable: false,
      sessionStorageAvailable: false,
    }
  }

  return {
    cookiesEnabled: areCookiesEnabled(),
    localStorageAvailable: isStorageAvailable("local"),
    sessionStorageAvailable: isStorageAvailable("session"),
  }
}
